<template>
    <svg width="100px" height="100px" viewBox="0 0 100 100" class="selectSVG">
        <defs>
            <path
                id="select-path-1"
                d="M33.8541667,67.7083333 C43.1857639,67.7083333 51.1610243,64.3988715 57.7799479,57.7799479 C64.3988715,51.1610243 67.7083333,43.1857639 67.7083333,33.8541667 L67.7083333,33.8541667 L60.8723958,33.8541667 C60.8723958,41.3411458 58.2411024,47.7159288 52.9785156,52.9785156 C47.7159288,58.2411024 41.3411458,60.8723958 33.8541667,60.8723958 C26.3671875,60.8723958 19.9924045,58.2411024 14.7298177,52.9785156 C9.4672309,47.7159288 6.8359375,41.3411458 6.8359375,33.8541667 C6.8359375,26.3671875 9.4672309,19.9924045 14.7298177,14.7298177 C19.9924045,9.4672309 26.3671875,6.8359375 33.8541667,6.8359375 C36.4583333,6.8359375 38.9539931,7.16145833 41.3411458,7.8125 L41.3411458,7.8125 L46.5494792,2.60416667 C42.4262153,0.868055556 38.1944444,0 33.8541667,0 C24.5225694,0 16.547309,3.30946181 9.92838542,9.92838542 C3.30946181,16.547309 0,24.5225694 0,33.8541667 C0,43.1857639 3.30946181,51.1610243 9.92838542,57.7799479 C16.547309,64.3988715 24.5225694,67.7083333 33.8541667,67.7083333 Z M30.4361979,47.3632812 L63.5832578,14.2162214 C63.9737821,13.8256971 63.9737821,13.1925321 63.5832578,12.8020078 L60.2754414,9.49419136 C59.8856904,9.10444035 59.2540525,9.10355571 58.8632113,9.49221345 L30.4361979,37.7604167 L30.4361979,37.7604167 L20.7387245,28.0629432 C20.3482002,27.6724189 19.7150352,27.6724189 19.3245109,28.0629432 C19.3205163,28.0669378 19.3165556,28.0709662 19.3126293,28.0750279 L15.9828211,31.5196571 C15.6035629,31.9119932 15.6088501,32.5359334 15.9947026,32.921786 L30.4361979,47.3632812 L30.4361979,47.3632812 Z"
            ></path>
        </defs>
        <g id="Asset-Artboard-Page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Icons-/-Search-Icons-/-Regular-/-Select">
                <g id="Color-/-Grey" transform="translate(16.666667, 16.666667)">
                    <mask id="select-mask-2" fill="white">
                        <use xlink:href="#select-path-1"></use>
                    </mask>
                    <use
                        id="Mask"
                        fill="#646C9A"
                        fill-rule="nonzero"
                        xlink:href="#select-path-1"
                    ></use>
                    <g
                        id="Color-/-Grey-Color-/-Purple-/-Regular"
                        mask="url(#select-mask-2)"
                        fill="#5B74FF"
                    >
                        <g id="Color-/-Dark-Grey" transform="translate(-50.000000, -50.000000)">
                            <rect x="0" y="0" width="166.666672" height="166.666672"></rect>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'SelectSVG',
};
</script>

<style lang="scss" scoped>
.selectSVG {
    position: absolute;
    top: 58px;
    left: 58px;
}
</style>
